
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'en';
    setLanguage(storedLanguage);
    document.documentElement.dir = storedLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = storedLanguage;
  }, []);

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'ar' : 'en';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    document.documentElement.dir = newLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLanguage;
  };

  const t = (key) => {
    const translations = {
      en: {
        dashboard: 'Dashboard',
        pipeline: 'Sales Pipeline',
        projects: 'Projects',
        archived: 'Archived',
        hrDashboard: 'HR Dashboard',
        residence: 'Residence Management',
        dailyReports: 'Daily Reports',
        myAttendance: 'My Attendance',
        myOvertime: 'My Overtime',
        companyFiles: 'Company Files',
        overhead: 'Overhead Costs',
        users: 'Users & Roles',
        settings: 'Settings',
        profile: 'Profile',
        logout: 'Logout',
        platform: 'Platform',
        humanResources: 'Human Resources',
        management: 'Management',
        account: 'Account'
      },
      ar: {
        dashboard: 'لوحة القيادة',
        pipeline: 'مسار المبيعات',
        projects: 'المشاريع',
        archived: 'المؤرشف',
        hrDashboard: 'لوحة الموارد البشرية',
        residence: 'إدارة الإقامة',
        dailyReports: 'التقارير اليومية',
        myAttendance: 'حضوري',
        myOvertime: 'العمل الإضافي',
        companyFiles: 'ملفات الشركة',
        overhead: 'التكاليف العامة',
        users: 'المستخدمون والأدوار',
        settings: 'الإعدادات',
        profile: 'الملف الشخصي',
        logout: 'تسجيل الخروج',
        platform: 'المنصة',
        humanResources: 'الموارد البشرية',
        management: 'الإدارة',
        account: 'الحساب'
      }
    };

    return translations[language][key] || key;
  };

  const value = {
    language,
    toggleLanguage,
    t,
    isRTL: language === 'ar'
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
